.full-text-search {
  max-width: 720px !important;
}
